import { fetchCompanyListOf } from './company-list';
import { fetchModelImageListOf } from './model-image-list';
import { fetchLabelListOf } from './model-label-list';
import { fetchModelListOf } from './model-list';
import { fetchTrainingListOf } from './model-training-list';
import { fetchProjectImageListOf } from './project-image-list';
import { fetchProjectListOf } from './project-list';

export const fetchKoumutenRelatedList = (koumutenId: number) =>
  fetchCompanyListOf(koumutenId);

export const fetchCompanyRelatedList = (companyId: number) => {
  fetchProjectListOf(companyId);
  fetchModelListOf(companyId);
};

export const fetchProjectRelatedList = (projectId: number) => {
  fetchProjectImageListOf(projectId);
};

export const fetchModelRelatedList = (modelId: number) => {
  fetchModelImageListOf(modelId);
  fetchLabelListOf(modelId);
  fetchTrainingListOf(modelId);
};
